/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
// libraries
import React, { useState, useEffect } from 'react';
import { useSelector } from 'react-redux';
// utils

// material
import { Page, Content } from '@insticator/insticator-ui';
import Header from '../../../../material/structure/header/header';
import GlobalFilter from '../../../../material/globalfilter/globalfilter';
import PageHeader from '../../../../material/structure/pageheader/pageheader';
import PageContent from '../../../../material/structure/pagecontent/pagecontent';

// styles
import injectSheet from 'react-jss';
import styles from './mobileapp_styles';


/* ========== ~~~~~~~~~~ MONETIZATION - ENGAGEMENT PRODUCTS PAGE ~~~~~~~~~~ ========== */
const MobileAppPage = injectSheet(styles)((props) => {
    return (
        <Page name={'mobileApp'} klass={`${props.classes.mobileApp}`} >
            <Header>
                <GlobalFilter onFilterApply={props.dataRequest} />
            </Header>
            <Content>
                <PageHeader lastUpdatedTimestamp={new Date()} title={'Monetization'} subtitle={'Mobile App'} dataTip={true} />
                <PageContent>
                    BETA PAGE!
                </PageContent>
            </Content>
        </Page>
    );
});


/* ++++++++++ --------------- EXPORTS --------------- ++++++++++ */
export default MobileAppPage;
